/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Title_Project_ImportInputs */

const en_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Import`)
};

const fr_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet`)
};

const de_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport`)
};

const it_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto`)
};

const ru_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта`)
};

const es_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de proyectos`)
};

const zh_cn2_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入`)
};

const ja_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポート`)
};

const hi_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात`)
};

const pt_pt2_ateliere_connect_title_project_import = /** @type {(inputs: Ateliere_Connect_Title_Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de Projetos`)
};

/**
* | output |
* | --- |
* | "Project Import" |
*
* @param {Ateliere_Connect_Title_Project_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_title_project_import = /** @type {((inputs?: Ateliere_Connect_Title_Project_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Title_Project_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_title_project_import(inputs)
	if (locale === "de") return de_ateliere_connect_title_project_import(inputs)
	if (locale === "it") return it_ateliere_connect_title_project_import(inputs)
	if (locale === "ru") return ru_ateliere_connect_title_project_import(inputs)
	if (locale === "es") return es_ateliere_connect_title_project_import(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_title_project_import(inputs)
	if (locale === "ja") return ja_ateliere_connect_title_project_import(inputs)
	if (locale === "hi") return hi_ateliere_connect_title_project_import(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_title_project_import(inputs)
	return en_ateliere_connect_title_project_import(inputs)
});